module.exports = __webpack_public_path__ + "assets/img/kv-2c0ee866.jpg";